var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimetable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Timetable",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m55 5h-4v-1c0-2.21-1.79-4-4-4s-4 1.79-4 4v4c0 .76.43 1.41 1.05 1.75.11-.43.49-.75.95-.75.55 0 1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1v-.14c-1.72-.45-3-2-3-3.86v-3h-21v-1c0-2.21-1.79-4-4-4s-4 1.79-4 4v4c0 .76.43 1.41 1.05 1.75.11-.43.49-.75.95-.75.55 0 1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1v-.14c-1.72-.45-3-2-3-3.86v-3h-6c-2.21 0-4 1.79-4 4v46c0 2.21 1.79 4 4 4h51c2.21 0 4-1.79 4-4v-46c0-2.21-1.79-4-4-4zm-10 0v-1c0-1.1.9-2 2-2s2 .9 2 2v1zm-31 0v-1c0-1.1.9-2 2-2s2 .9 2 2v1zm43 50c0 1.1-.9 2-2 2h-51c-1.1 0-2-.9-2-2v-38h55z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 5,
    y: 21
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 31,
    y: 21
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 44,
    y: 21
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 5,
    y: 33
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 18,
    y: 33
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 31,
    y: 33
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 44,
    y: 33
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 5,
    y: 45
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 18,
    y: 45
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 31,
    y: 45
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 10,
    x: 44,
    y: 45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.293 28.707c.188.188.4424.293.707.293l.0454-.001c.2808-.0127.543-.1431.7227-.3589l5-6c.3535-.4243.2964-1.0547-.1279-1.4082-.4243-.354-1.0552-.2964-1.4082.1279l-4.2993 5.1587-2.2256-2.2256c-.3906-.3906-1.0234-.3906-1.4141 0s-.3906 1.0234 0 1.4141z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m61 9.13v9.87h3v-6c0-1.86-1.27-3.43-3-3.87z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m61 55c0 3.31-2.69 6-6 6h-48.87c.44 1.73 2.01 3 3.87 3h50c2.21 0 4-1.79 4-4v-39h-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimetable);
export default __webpack_public_path__ + "static/media/timetable.f637df439ca2ddd6309a80bcf770c63c.svg";
export { ForwardRef as ReactComponent };